// extracted by mini-css-extract-plugin
export default {"settings_container":"settings-page_settings_container__ybErp","fadeInOut":"settings-page_fadeInOut__Xelfm"};